import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JgPhysicalInspUnitFxItemForm } from '../models/jg/jg-physical-insp-unit-fx-item-form.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class JgPhysicalInspUnitFxItemFormService extends RequestService<JgPhysicalInspUnitFxItemForm> {
  static PATH = '/jg/physicalInsp/unitFx/item/form';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(
      httpClient,
      JgPhysicalInspUnitFxItemFormService.PATH,
      globalService.debugUrl,
    );
  }
}
